import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const FR_ORIGIN = 'https://smartlawyer.ai';
const INTL_ORIGIN = 'https://dev.smartlawyer.ai';

/**
 * Balises hreflang pour la page courante (hreflang = langue de l'interface,
 * pas la juridiction).
 *
 * FR → smartlawyer.ai, EN → dev.smartlawyer.ai, DE → dev.smartlawyer.ai?lang=de,
 * x-default FR.
 */
export function HreflangLinks({ path }: { path?: string }) {
  const { pathname } = useLocation();
  const p = path ?? pathname;

  return (
    <Helmet>
      <link rel="alternate" hrefLang="fr" href={`${FR_ORIGIN}${p}`} />
      <link rel="alternate" hrefLang="en" href={`${INTL_ORIGIN}${p}`} />
      <link rel="alternate" hrefLang="de" href={`${INTL_ORIGIN}${p}?lang=de`} />
      <link rel="alternate" hrefLang="x-default" href={`${FR_ORIGIN}${p}`} />
    </Helmet>
  );
}

export default HreflangLinks;
